
// 折线图
function lineCharts(color, xdata, data) {
  const optionData = {
    grid: {
      left: '10%',
      right: '10%',
      top: '10%',
      bottom: '10%',
      containLabel: true
    },
    color: [color],
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderColor: '#ccc',
      borderRadius: 4,
      borderWidth: 1,
      extraCssText: 'box-shadow:0 0 5px #ccc',
      textStyle: {
        color: '#666'
      }
    },
    xAxis: [
      {
        splitLine: { show: false },
        type: 'category',
        boundaryGap: false,
        data: xdata,
        axisLine: {
          lineStyle: {
            color: '#ccc'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#bbb',
            fontSize:10
          },
          interval: 0, // 横轴信息全部显示
          rotate:45
          //标签过长换行
          /* formatter: function(val) {
            var value = val.replace(/\s+/g, '')
            var ret = ''// 拼接加\n返回的类目项
            var maxLength = 5// 每项显示文字个数
            var valLength = value.length// X轴类目项的文字个数
            var rowN = Math.ceil(valLength / maxLength) // 类目项需要换行的行数
            if (rowN > 1)// 如果类目项的文字大于3,
            {
              for (var i = 0; i < rowN; i++) {
                var temp = ''// 每次截取的字符串
                var start = i * maxLength// 开始截取的位置
                var end = start + maxLength// 结束截取的位置
                // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                temp = value.substring(start, end) + '\n'
                ret += temp // 凭借最终的字符串
              }
              return ret
            } else {
              return value
            }
          } */
        }
      }
    ],
    yAxis: [
      {
        splitLine: { show: false },
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#ccc'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#bbb'
          }
        }
      }
    ],
    series: [
      {
        name: '',
        type: 'line',
        smooth: true,
        itemStyle: {
          normal: {
            areaStyle: { type: 'default' },
            lineStyle: {
              color: color,
              width: 2
            }
          }
        },
        data: data
      }
    ]
  }
  return optionData
}
// 堆叠柱状图
function barStackCharts(xdata, data) {
  const optionData = {
    grid: {
      left: '3%',
      right: '3%',
      top: '20%',
      bottom: '4%',
      containLabel: true
    },
    color: ['#3ba1ff', '#fadc64', '#4aeeb7', '#fe968b', '#975fe4'],
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderColor: '#ccc',
      borderRadius: 4,
      borderWidth: 1,
      extraCssText: 'box-shadow:0 0 5px #ccc',
      textStyle: {
        color: '#666'
      }
    },
    legend: {
      orient: 'horizontal',
      itemWidth: 8,
      itemHeight: 8,
      itemGap: 2,
      textStyle: { fontSize: 11, color: '#bbb' }
      // data: ['一级故障', '二级故障', '三级故障', '四级故障']
    },
    xAxis: [
      {
        splitLine: { show: false },
        type: 'category',
        boundaryGap: true,
        data: xdata,
        axisLine: {
          lineStyle: {
            color: '#ccc'
          }
        },
        axisLabel: {
          show: true,
          interval: 0, // 横轴信息全部显示
          textStyle: {
            color: '#bbb'
          }
        }
      }
    ],
    yAxis: [
      {
        splitLine: {
          show: true,
          lineStyle: {
            color: '#bbb',
            type: 'dashed'
          }
        },
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#ccc'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#bbb'
          },
          formatter: '{value}'
        }
      }
    ],
    series: data
  }
  return optionData
}
// 横向柱状图
function barHorizontalCharts(color, xdata, data) {
  const optionData = {
    grid: {
      left: '3%',
      right: '3%',
      top: '5%',
      bottom: '2%',
      containLabel: true
    },
    color: [color],
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderColor: '#ccc',
      borderRadius: 4,
      borderWidth: 1,
      extraCssText: 'box-shadow:0 0 5px #ccc',
      textStyle: {
        color: '#666'
      }
    },
    xAxis: [
      {
        splitLine: {
          show: false
          // lineStyle: {
          //   color: '#f2f2f2',
          //   type: 'dashed'
          // }
        },
        type: 'value',
        boundaryGap: true,
        axisLine: {
          lineStyle: {
            color: '#ccc'
          }
        },
        axisLabel: {
          show: true,
          interval: 0, // 横轴信息全部显示
          // rotate: 30, // -15度角倾斜显示
          textStyle: {
            color: '#bbb'
          }
        }
      }
    ],
    yAxis: [
      {
        splitLine: {
          show: false,
          lineStyle: {
            color: '#f2f2f2',
            type: 'dashed'
          }
        },
        type: 'category',
        data: xdata,
        axisLine: {
          lineStyle: {
            color: '#ccc'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#bbb'
          }
        }
      }
    ],
    series: [
      {
        name: '',
        type: 'bar',
        barWidth: 10, // 柱图宽度
        // itemStyle: {
        //   normal: {
        //     areaStyle: { type: 'default' },
        //     lineStyle: {
        //       color: '#49a9ee',
        //       width: 2
        //     }
        //   }
        // },
        data: data
      }
    ]
  }
  return optionData
}
// 竖向柱状图
function barCharts(color, xdata, data) {
  const optionData = {
    grid: {
      left: '10%',
      right: '10%',
      top: '10%',
      bottom: '10%',
      containLabel: true
    },
    color: [color],
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderColor: '#ccc',
      borderRadius: 4,
      borderWidth: 1,
      extraCssText: 'box-shadow:0 0 5px #ccc',
      textStyle: {
        color: '#666'
      }
    },
    xAxis: [
      {
        splitLine: { show: false },
        type: 'category',
        boundaryGap: false,
        data: xdata,
        axisLine: {
          lineStyle: {
            color: '#ccc',
          }
        },
        axisLabel: {
          //标签换行
         /*  formatter: function(value) {
            var ret = ''// 拼接加\n返回的类目项
            var maxLength = 4// 每项显示文字个数
            var valLength = value.length// X轴类目项的文字个数
            var rowN = Math.ceil(valLength / maxLength) // 类目项需要换行的行数
            if (rowN > 1)// 如果类目项的文字大于3,
            {
              for (var i = 0; i < rowN; i++) {
                var temp = ''// 每次截取的字符串
                var start = i * maxLength// 开始截取的位置
                var end = start + maxLength// 结束截取的位置
                // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                temp = value.substring(start, end) + '\n'
                ret += temp // 凭借最终的字符串
              }
              return ret
            } else {
              return value
            }
          }, */
          rotate:45,
          interval: 0, // 横轴信息全部显示
          // rotate: 10, // -15度角倾斜显示
          show: true,
          textStyle: {
            color: '#bbb',
            fontSize:10
          }
        }
      }
    ],
    yAxis: [
      {
        splitLine: {
          show: true,
          lineStyle: {
            color: '#bbb',
            type: 'dashed'
          }
        },
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#ccc'
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: '#bbb'
          }
        }
      }
    ],
    series: [
      {
        name: '',
        type: 'bar',
        barWidth: 15, // 柱图宽度
        itemStyle: {
          normal: {
            barBorderRadius: [3, 3, 0, 0],
            areaStyle: { type: 'default' },
            lineStyle: {
              color: '#49a9ee',
              width: 2
            }
          }
        },
        data: data
      }
    ]
  }
  return optionData
}
// 环形图
function pieCharts(data) {
  const optionData = {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderColor: '#ccc',
      borderRadius: 4,
      borderWidth: 1,
      extraCssText: 'box-shadow:0 0 5px #ccc',
      textStyle: {
        color: '#666'
      },
      formatter: '{b}: {c}%'
    },
    color: ['#3ba1ff', '#975fe4', '#fe968b', '#4aeeb7'],
    legend: {
      y: 'bottom',
      padding: [0, 0, 10, 0],
      orient: 'horizontal',
      itemWidth: 8,
      itemHeight: 8,
      itemGap: 2,
      textStyle: { fontSize: 11, color: '#bbb' }
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['40%', '60%'],
        center: ['50%', '40%'],
        itemStyle: {
          normal: {
            label: {
              show: true
            },
            labelLine: {
              show: true
            }
          },
          emphasis: {
            label: {
              show: true,
              position: 'center',
              textStyle: {
                fontSize: '14',
                fontWeight: 'bold'
              }
            }
          }
        },
        data: data
      }
    ]
  }
  return optionData
}
// 雷达图
function radarCharts(indicator, color, data) {
  const optionData = {
    tooltip: {
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderColor: '#ccc',
      borderRadius: 4,
      borderWidth: 1,
      extraCssText: 'box-shadow:0 0 5px #ccc',
      textStyle: {
        color: '#666'
      }
    },
    textStyle: {
      color: '#bbb'
    },
    radar: {
      axisLine: {
        lineStyle: {
          opacity: 0.4,
          color: color // 分割线
        }
      },
      splitArea: {
        show: false
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0.4,
          color: color // 设置网格的颜色
        }
      },
      indicator: indicator,
      radius: 60
    },
    series: [{
      name: '充电情况分布',
      type: 'radar',
      // 边框
      itemStyle: {
        normal: {
          color: color,
          lineStyle: {
            color: color
          }
        }
      },
      // 区域
      areaStyle: {
        normal: {
          opacity: 0.2,
          color: color // 选择区域颜色
        }
      },
      data: data
    }]
  }
  return optionData
}
// 中国地图
function chinaCharts(color, data) {
  const optionData = {
    // 新建一个地理坐标系 geo ，
    geo: {
      map: 'china', // 地图类型为中国地图,要是世界那就是world,要是省市区：例如beijing、shanghai
      itemStyle: { // 定义样式
        normal: { // 普通状态下的样式
          areaColor: color,
          borderColor: '#fff'
        },
        emphasis: { // 高亮状态下的样式
          areaColor: '#e9fbf1'
        }
      },
      label: {
        show: true,
        color: '#fff',
        emphasis: {
          show: true,
          color: '#666'
        }
      }
    },
    tooltip: {
      formatter: function(params) {
        return params.name + ' : ' + params.data.cunt
      },
      trigger: 'item',
      backgroundColor: 'rgba(255,255,255,0.7)',
      borderColor: '#ccc',
      borderRadius: 4,
      borderWidth: 1,
      extraCssText: 'box-shadow:0 0 5px #ccc',
      textStyle: {
        color: '#666'
      }
    },
    // 标志颜色
    color: 'yellow',
    // 新建散点图series
    series: [{
      name: '', // series名称
      type: 'effectScatter', // 为散点类型
      coordinateSystem: 'geo', // series坐标系类型
      data: data,
      // symbol: 'pin',
      symbolSize: [15, 15],
      rippleEffect: {
        brushType: 'stroke'
      }
    }]
  }
  return optionData
}
export {
  lineCharts,
  barStackCharts,
  barHorizontalCharts,
  barCharts,
  pieCharts,
  radarCharts,
  chinaCharts
}
